import { render } from "./CreateIssue.vue?vue&type=template&id=b8056590"
import script from "./CreateIssue.vue?vue&type=script&lang=js"
export * from "./CreateIssue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__